// extracted by mini-css-extract-plugin
export default {"profile":"Profile__profile___U517z"};